(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SessionType', SessionType);

    SessionType.$inject = ['$resource'];

    function SessionType ($resource) {
        var resourceUrl =  'api/session-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/session-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
